import React from 'react';
import { withTranslation } from '../../ChildrenContext';
import PropTypes from 'prop-types';
import DocumentListContainer from './DocumentList/DocumentListContainer';

const InformationPage = ({ t }) => {
    const staticNames = t?.InformationPage || {};

    return (
        <React.Fragment>
            <div className="page-heading">
                <div className="page-heading__inner">
                    <h2>{staticNames.title}</h2>
                </div>
            </div>
            <section className="wrapper-content">
                <DocumentListContainer/>
            </section>
        </React.Fragment>
    );
};

InformationPage.propTypes = {
    t: PropTypes.object
};

InformationPage.defaultProps = {
    t: {}
};

export default withTranslation(InformationPage);
